module.exports = __webpack_public_path__ + "static/spreadsheet-5f35aae40c0ce4be38cd09a64d885224.png";